import apiTariff from '@/api/tariff'
import {propOr} from 'ramda'

const state = {
  data: [],
  isLoading: false,
  error: null,
  total: null
}

export const mutationTypes = {
  getTariffStart: '[tariff] Get tariff start',
  getTariffSuccess: '[tariff] Get tariff success',
  getTariffFailure: '[tariff] Get tariff failure'
}

export const actionTypes = {
  getTariff: '[tariff] Get trainer'
}

const mutations = {
  [mutationTypes.getTariffStart](state) {
    state.isLoading = true
    state.data = []
  },

  [mutationTypes.getTariffSuccess](state, payload) {
    state.data = payload.data ? payload.data : payload
    state.total = payload.total ? payload.total : 100
    state.isLoading = false
  },

  [mutationTypes.getTariffFailure](state) {
    state.isLoading = false
  }
}

const actions = {
  [actionTypes.getTariff](context, data) {
    const params = propOr(null, 'params', data)
    context.commit(mutationTypes.getTariffStart)
    return new Promise(resolve => {
      apiTariff
        .getTariff(params)
        .then(response => {
          context.commit(mutationTypes.getTariffSuccess, response.data)
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.getTariffFailure)
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
